import * as React from 'react';
import { Icon } from './icon';

import styled, { css } from 'styled-components';

const determineSize = props => {
  switch (props.size) {
    case 'big':
      return css`
        width: 48px;
        height: 48px;
        i {
          font-size: 34px;
        }
      `;
    case 'small':
    default:
      return css`
        width: 32px;
        height: 32px;
        i {
          font-size: 18px;
        }
      `;
  }
};

const StyledIconButton = styled.button`
  position: absolute;
  top: 24px;
  cursor: pointer;
  border: 2px solid ${props => props.theme.colors.outlineLight};
  outline: none;
  border-radius: ${props => (props.rounded ? '50%' : '8px')};
  color: #c7c7d6;
  background: ${props => props.theme.backgrounds.tertiaryDark};
  ${props => determineSize(props)};
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.15));
  margin: 0 20px;

  &:hover {
    filter: drop-shadow(0px 8px 18px rgba(0, 0, 0, 0.3));
    border: 2px solid #30334e;
  }

  &:active {
    opacity: 0.8;
  }

  ${props =>
    props.disabled &&
    css`
      opacity: 0.6;
      color: #30334e;
      pointer-events: none;
    `}
`;

export const IconButton = ({
  iconName = 'arrow_back',
  size = 'big',
  rounded = true,
  disabled = false,
  iconVariant,
  ...rest
}) => {
  return (
    <StyledIconButton
      rounded={rounded}
      size={size}
      disabled={disabled}
      {...rest}
    >
      <Icon name={iconName} variant={iconVariant} />
    </StyledIconButton>
  );
};
